import React from 'react'
import Card from '../../components/Card.jsx'

export default function Learning() {
  return (
    <div className="page active">
      <div className="page-inner">
        <div className="hero">
          <p className="hero-eyebrow">Growth</p>
          <h1><em>Exercises</em></h1>
          <hr className="hero-rule" />
        </div>
        <Card label="Growth" title="Exercises">
          <p style={{ color: 'var(--bark)', lineHeight: '1.8' }}>
            Coming soon — this section is being built.
          </p>
        </Card>
      </div>
    </div>
  )
}
